export function createProfileApi(baseUrl) {
  return {
    profile: {
      getProfile: `${baseUrl}/v1/profile/`,
      getDonations: `${baseUrl}/v1/profile/donations/`,
      getPulseSubscriptions: `${baseUrl}/v2/profile/pulse/`,
      acceptInvite: (id) => `${baseUrl}/v1/profile/promo/${id}/`,
      appLink: (id) => `${baseUrl}/v1/profile/${id}/links/`,
    },
  };
}
